(function () {
  'use strict';

  var cfg = window.ultimateLiving || {};
  var productJsonEl = document.querySelector('[data-product-json]');
  var pricingJsonEl = document.querySelector('[data-pdp-pricing]');
  var product = null;
  var pricingCfg = {
    subSavePct: 0,
    subUnitCents: 0,
    annualSaveCents: 0,
    retailUnitCents: 0,
    servingsPerTub: 30,
    defaultSellingPlanId: null,
    hasSellingPlan: false,
    volumeRates: { 2: 0.9, 3: 0.8, 4: 0.75, 5: 0.7, 6: 0.65 }
  };

  if (productJsonEl) {
    try {
      product = JSON.parse(productJsonEl.textContent);
    } catch (e) {
      product = null;
    }
  }

  if (pricingJsonEl) {
    try {
      pricingCfg = Object.assign(pricingCfg, JSON.parse(pricingJsonEl.textContent));
    } catch (e) {
      /* keep defaults */
    }
  }

  var subDiscountBadge = document.querySelector('[data-sub-discount-badge]');
  var subPerkPrimary = document.querySelector('[data-sub-perk-primary]');
  var subPitchSection = document.querySelector('[data-sub-pitch]');
  var poRoot = document.querySelector('.po[data-has-selling-plan]');
  var hasSellingPlan = pricingCfg.hasSellingPlan !== false && !!pricingCfg.defaultSellingPlanId;
  if (poRoot && poRoot.dataset.hasSellingPlan === 'false') {
    hasSellingPlan = false;
  }

  var qtyPills = document.querySelectorAll('.qty-pill');
  var poCards = document.querySelectorAll('.po__card');
  var atcTotal = document.getElementById('atc-total');
  var qtyInput = document.querySelector('[data-qty-input]');
  var variantInput = document.querySelector('[data-variant-id]');
  var priceNow = document.querySelector('.buy__price .now');
  var priceWas = document.querySelector('.buy__price .was');
  var priceSave = document.querySelector('.buy__price .save');
  var poCompare = document.querySelector('[data-po-compare]');
  var poUnitSub = document.querySelector('[data-po-unit="sub"]');
  var poUnitOne = document.querySelector('[data-po-unit="one"]');
  var sellingPlanInput = document.querySelector('[data-selling-plan-input]');
  var atcButton = document.querySelector('.buy__atc button[type="submit"]');
  var buyAvail = document.getElementById('buyAvail');
  // Default qty: read from the active pill if one exists, otherwise 1.
  var initialActivePill = document.querySelector('.qty-pill.active');
  var initialQty = initialActivePill ? (parseInt(initialActivePill.dataset.qty, 10) || 1) : 1;
  // unitCents: when a purchase-option card declares its own per-unit price
  // (the 3-up selector's One-time / Two-tubs cards via data-unit-cents), recalc
  // uses it directly instead of the volume-tier calc. null = fall back to tiers.
  // totalCents: a purchase-option card may declare a fixed total (data-total-cents,
  // e.g. the Two-Tubs promo price) so the ATC total is exact and not unit*qty rounded.
  var state = { qty: initialQty, po: hasSellingPlan ? 'sub' : 'one', unitCents: null, totalCents: null };

  // Hide stray Recharge widgets that mount OUTSIDE our buy box (e.g. duplicate
  // injections at the bottom of the page). Keep widgets inside .buy or
  // [data-rc-mount] visible — those are the canonical ones.
  function suppressStrayRechargeWidgets() {
    var selectors = ['.rc-container', '.rc-widget', '.rc_popup__widget', 'recharge-subscriptions-widget'];
    function hideStray(node) {
      if (!node) return;
      if (node.closest('.buy') || node.closest('[data-rc-mount]')) return;
      node.setAttribute('hidden', 'hidden');
      node.style.setProperty('display', 'none', 'important');
    }
    function sweep() {
      selectors.forEach(function (sel) { document.querySelectorAll(sel).forEach(hideStray); });
    }
    sweep();
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(sweep);
      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  suppressStrayRechargeWidgets();

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, cfg.moneyFormat || '${{amount}}');
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function currentVariant() {
    if (!product || !product.variants || !product.variants.length) return null;
    var id = variantInput ? parseInt(variantInput.value, 10) : product.variants[0].id;
    return product.variants.find(function (v) { return v.id === id; }) || product.variants[0];
  }

  function percentOff(retailCents, discountedCents) {
    if (!retailCents || !discountedCents || discountedCents >= retailCents) return 0;
    return Math.round((retailCents - discountedCents) * 100 / retailCents);
  }

  function retailUnitCents() {
    var variant = currentVariant();
    if (variant) return variant.price;
    return pricingCfg.retailUnitCents || 0;
  }

  function volumeTierUnitCents(qty) {
    var base = retailUnitCents();
    var rates = pricingCfg.volumeRates || { 2: 0.9, 3: 0.8, 4: 0.75, 5: 0.7, 6: 0.65 };
    var rate = rates[String(qty)];
    if (rate) return Math.round(base * rate);
    return base;
  }

  function tierUnitCents(qty) {
    return volumeTierUnitCents(qty);
  }

  function subSavePct() {
    var retail = retailUnitCents();
    var sub = subUnitCents();
    var pct = percentOff(retail, sub);
    if (pct > 0) return pct;
    return pricingCfg.subSavePct || 0;
  }

  function annualSaveCents() {
    var retail = retailUnitCents();
    var sub = subUnitCents();
    if (sub < retail) return (retail - sub) * 12;
    return pricingCfg.annualSaveCents || 0;
  }

  function formatPerServing(unitCents, servings) {
    if (!servings || servings <= 0) servings = 30;
    return formatMoney(Math.round(unitCents / servings));
  }

  function updateQtyTierLabels() {
    var baseUnit = retailUnitCents();
    var qtyPillsEl = document.querySelector('[data-qty-pills]');
    var servings = qtyPillsEl ? parseInt(qtyPillsEl.dataset.servingsPerTub, 10) : pricingCfg.servingsPerTub;
    if (!servings || isNaN(servings)) servings = 30;

    qtyPills.forEach(function (pill) {
      var qty = parseInt(pill.dataset.qty, 10);
      if (!qty || isNaN(qty)) return;
      var unit = volumeTierUnitCents(qty);
      pill.dataset.unitPriceCents = String(unit);

      var eachEl = pill.querySelector('[data-qty-serving]') || pill.querySelector('.qty-each strong');
      if (eachEl) {
        eachEl.textContent = formatPerServing(unit, servings);
      }

      var savingEl = pill.querySelector('[data-qty-saving]') || pill.querySelector('.qty-saving');
      if (!savingEl) return;
      var saveCents = (baseUnit - unit) * qty;
      if (saveCents > 0) {
        savingEl.textContent = 'Save ' + formatMoney(saveCents);
      } else {
        savingEl.textContent = '\u00a0';
      }
    });
  }

  function selectedOptionValues() {
    var values = [];
    document.querySelectorAll('.variant-picker').forEach(function (picker) {
      var active = picker.querySelector('.variant-picker__option.active');
      if (active) values.push(active.dataset.optionValue);
    });
    return values;
  }

  function findVariantByOptions(values) {
    if (!product || !product.variants) return null;
    return product.variants.find(function (variant) {
      for (var i = 0; i < values.length; i += 1) {
        if (variant['option' + (i + 1)] !== values[i]) return false;
      }
      return true;
    });
  }

  function updateGalleryForVariant(variant) {
    if (!variant || !product || !product.media) return;
    var mediaId = variant.featured_media && variant.featured_media.id
      ? variant.featured_media.id
      : variant.featured_media;
    if (!mediaId) return;
    // Prefer scrolling the new track to the right slide.
    if (typeof window.__galleryScrollToMediaId === 'function') {
      window.__galleryScrollToMediaId(mediaId);
      return;
    }
    // Fallback for any stale markup: swap the first img src.
    var galleryImg = document.getElementById('gallery-img');
    var media = product.media.find(function (m) { return m.id === mediaId; });
    if (galleryImg && media && media.preview_image && media.preview_image.src) {
      galleryImg.src = media.preview_image.src;
      galleryImg.alt = media.alt || product.title;
    }
  }

  function updatePoPrices(tierUnitCents, subUnitCents, compareUnitCents) {
    if (poUnitOne) poUnitOne.textContent = formatMoney(tierUnitCents);
    if (poUnitSub) poUnitSub.textContent = formatMoney(subUnitCents);

    if (poCompare) {
      if (subUnitCents < compareUnitCents) {
        poCompare.textContent = formatMoney(compareUnitCents);
        poCompare.hidden = false;
      } else {
        poCompare.hidden = true;
      }
    }
  }

  function sellingPlanAllocation(variant, planId) {
    if (!variant || !planId || !variant.selling_plan_allocations) return null;
    var targetId = parseInt(planId, 10);
    return variant.selling_plan_allocations.find(function (allocation) {
      return parseInt(allocation.selling_plan_id, 10) === targetId;
    }) || null;
  }

  function subUnitCents() {
    var variant = currentVariant();
    // Prefer the runtime-selected plan (dropdown), fall back to Liquid default.
    var plan = activePlan();
    var allocation = sellingPlanAllocation(variant, state.sellingPlanId || pricingCfg.defaultSellingPlanId);
    if (allocation && allocation.price) return allocation.price;
    if (plan && plan.unitCents) return plan.unitCents;
    if (pricingCfg.subUnitCents && variant && variant.price === pricingCfg.retailUnitCents) {
      return pricingCfg.subUnitCents;
    }
    var retail = retailUnitCents();
    var pct = (plan && plan.savePct) || pricingCfg.subSavePct || 0;
    if (pct > 0) return Math.round(retail * (100 - pct) / 100);
    return retail;
  }

  function updateSubDiscountBadge() {
    if (!subDiscountBadge) return;
    // Prefer the precise % string from the active Recharge plan (e.g. "15.39")
    // so the displayed badge matches Recharge exactly instead of rounding.
    var plan = activePlan();
    if (plan && plan.savePctPrecise) {
      subDiscountBadge.textContent = '-' + plan.savePctPrecise + '%';
      return;
    }
    var pct = subSavePct();
    if (pct > 0) {
      subDiscountBadge.textContent = '-' + pct + '%';
    }
  }

  function updateSubPerkPrimary() {
    if (!subPerkPrimary || !hasSellingPlan) return;
    var pct = subSavePct();
    var annual = annualSaveCents();
    var label = pricingCfg.unitLabel || 'tub';
    if (pct > 0) {
      subPerkPrimary.innerHTML = '<strong>' + pct + '% off, every shipment.</strong> About ' + formatMoney(annual) + ' back a year on a ' + label + '-a-month plan.';
    }
  }

  function updateSubPitchSection() {
    if (!subPitchSection || !hasSellingPlan) return;
    var body = subPitchSection.querySelector('[data-sub-pitch-body]');
    var btn = subPitchSection.querySelector('[data-sub-pitch-btn]');
    var pct = subSavePct();
    var sub = subUnitCents();
    if (body && pct > 0) {
      body.textContent = 'Lock in ' + pct + '% off every shipment. Pause, swap, or cancel anytime from your account. Talk to a real human, no robots.';
    }
    if (btn && sub > 0) {
      btn.textContent = 'Start Subscription · ' + formatMoney(sub);
    }
  }

  // Active plan id can change via the frequency dropdown. Falls back to the
  // Liquid-rendered default when nothing is picked yet.
  state.sellingPlanId = pricingCfg.defaultSellingPlanId || null;

  function findPlan(id) {
    if (!id || !Array.isArray(pricingCfg.sellingPlans)) return null;
    var sid = String(id);
    for (var i = 0; i < pricingCfg.sellingPlans.length; i++) {
      if (String(pricingCfg.sellingPlans[i].id) === sid) return pricingCfg.sellingPlans[i];
    }
    return null;
  }

  function activePlan() {
    return findPlan(state.sellingPlanId);
  }

  function syncSellingPlan() {
    if (!sellingPlanInput) return;
    if (state.po === 'sub' && state.sellingPlanId) {
      sellingPlanInput.setAttribute('name', 'selling_plan');
      sellingPlanInput.value = String(state.sellingPlanId);
    } else {
      sellingPlanInput.removeAttribute('name');
      sellingPlanInput.value = '';
    }
  }

  function recalc() {
    updateQtyTierLabels();
    var tierUnit = tierUnitCents(state.qty);
    var retailUnit = retailUnitCents();
    var subUnit = subUnitCents();
    // First-delivery price for subscriptions (Recharge first-order discount).
    // The ATC reflects what the customer pays now: the discounted first delivery.
    var subFirstDisc = pricingCfg.subFirstDiscountCents || 0;
    var subAtcUnit = subFirstDisc > 0 ? Math.max(0, subUnit - subFirstDisc) : subUnit;
    // 3-up cards declare their own unit price (state.unitCents); qty-pill
    // products fall back to the volume-tier unit.
    var nonSubUnit = (state.unitCents != null) ? state.unitCents : tierUnit;
    var totalCents = (state.totalCents != null)
      ? state.totalCents
      : (state.po === 'sub' ? subAtcUnit * state.qty : nonSubUnit * state.qty);

    if (atcTotal) atcTotal.textContent = formatMoney(totalCents);
    // Only write sticky price, qtyInput, and selling_plan when the old purchase
    // widget (.po[data-has-selling-plan]) exists on this page. Without it,
    // state.po is always 'one' and pricingCfg has no data, so syncSellingPlan()
    // would strip name="selling_plan" and clear the value that Recharge v2's
    // inline script just set. Also, state.qty is always 1 on Recharge-widget
    // pages (nothing ever changes it), so writing it every 500ms would overwrite
    // the planQty that the inline syncSellingPlan() just wrote to qtyInput.
    if (poRoot) {
      if (qtyInput) qtyInput.value = String(state.qty);
      updatePoPrices((state.unitCents != null) ? retailUnit : tierUnit, subUnit, retailUnit);
      updateSubDiscountBadge();
      updateSubPerkPrimary();
      updateSubPitchSection();
      syncSellingPlan();
    }
  }

  function updateVariantUI(variant) {
    if (!variant) return;
    if (variantInput) variantInput.value = String(variant.id);

    if (priceNow) priceNow.textContent = formatMoney(variant.price);
    if (priceWas) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceWas.textContent = formatMoney(variant.compare_at_price);
        priceWas.style.display = '';
      } else {
        priceWas.style.display = 'none';
      }
    }
    if (priceSave) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        var pct = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        priceSave.textContent = 'Save ' + pct + '%';
        priceSave.style.display = '';
      } else {
        priceSave.style.display = 'none';
      }
    }

    if (atcButton) {
      atcButton.disabled = !variant.available;
    }

    if (buyAvail) {
      var stock = buyAvail.querySelector('.stock');
      if (stock) {
        stock.textContent = variant.available ? 'In Stock' : 'Sold out';
        stock.classList.toggle('stock--out', !variant.available);
      }
    }

    updateGalleryForVariant(variant);
    recalc();
  }

  // Arrow-key navigation across a radiogroup. Roving tabindex pattern: only
  // the active option is in the tab order; arrows move focus + selection.
  function bindRadiogroupArrows(items) {
    if (!items.length) return;
    items.forEach(function (item, idx) {
      item.addEventListener('keydown', function (e) {
        var key = e.key;
        var next = null;
        if (key === 'ArrowRight' || key === 'ArrowDown') next = items[(idx + 1) % items.length];
        else if (key === 'ArrowLeft' || key === 'ArrowUp') next = items[(idx - 1 + items.length) % items.length];
        else if (key === 'Home') next = items[0];
        else if (key === 'End') next = items[items.length - 1];
        else if (key === 'Enter' || key === ' ') { e.preventDefault(); item.click(); return; }
        if (next) {
          e.preventDefault();
          next.focus();
          next.click();
        }
      });
    });
  }

  function setRovingTabindex(items, activeItem) {
    items.forEach(function (it) { it.setAttribute('tabindex', it === activeItem ? '0' : '-1'); });
  }

  document.querySelectorAll('.variant-picker').forEach(function (picker) {
    var options = Array.prototype.slice.call(picker.querySelectorAll('.variant-picker__option'));
    options.forEach(function (btn) {
      btn.addEventListener('click', function () {
        options.forEach(function (option) {
          option.classList.remove('active');
          option.setAttribute('aria-checked', 'false');
        });
        btn.classList.add('active');
        btn.setAttribute('aria-checked', 'true');
        setRovingTabindex(options, btn);
        var variant = findVariantByOptions(selectedOptionValues());
        if (variant) updateVariantUI(variant);
      });
    });
    bindRadiogroupArrows(options);
  });

  var qtyPillsArr = Array.prototype.slice.call(qtyPills);
  qtyPillsArr.forEach(function (b) {
    b.addEventListener('click', function () {
      qtyPillsArr.forEach(function (x) {
        x.classList.remove('active');
        x.setAttribute('aria-checked', 'false');
      });
      b.classList.add('active');
      b.setAttribute('aria-checked', 'true');
      setRovingTabindex(qtyPillsArr, b);
      state.qty = parseInt(b.dataset.qty, 10) || 1;
      state.totalCents = null;
      recalc();
    });
  });
  bindRadiogroupArrows(qtyPillsArr);

  var poCardsArr = Array.prototype.slice.call(poCards);
  poCardsArr.forEach(function (b) {
    b.addEventListener('click', function () {
      poCardsArr.forEach(function (x) {
        x.classList.remove('active');
        x.setAttribute('aria-checked', 'false');
      });
      b.classList.add('active');
      b.setAttribute('aria-checked', 'true');
      setRovingTabindex(poCardsArr, b);
      state.po = b.dataset.po;
      // 3-up selector: a card may carry its own quantity + unit price (e.g.
      // "Two tubs" = qty 2 at full unit price). Old sub/one cards omit these,
      // so quantity stays driven by qty pills and unit price falls back to tiers.
      if (b.dataset.qty) state.qty = parseInt(b.dataset.qty, 10) || 1;
      state.unitCents = b.dataset.unitCents ? parseInt(b.dataset.unitCents, 10) : null;
      state.totalCents = b.dataset.totalCents ? parseInt(b.dataset.totalCents, 10) : null;
      // One-time clears the selling_plan input; subscribe restores the picked
      // plan (or the default) so the form posts the right value.
      if (state.po === 'one') {
        state.sellingPlanId = null;
      } else if (!state.sellingPlanId) {
        state.sellingPlanId = pricingCfg.defaultSellingPlanId || null;
      }
      syncSellingPlan();
      recalc();
      // Mirror the choice into the invisible Recharge widget so it stays
      // aligned with our UI (Recharge may also notify analytics, etc.).
      if (typeof pushToRecharge === 'function') pushToRecharge();
    });
  });
  bindRadiogroupArrows(poCardsArr);

  // Frequency picker — chip buttons drive the hidden select + Recharge state.
  // Event-delegated on document so the handler always works, even if Recharge
  // or any other script re-renders the buy box DOM after our IIFE runs.
  var freqSelect = document.querySelector('[data-selling-plan-select]');
  var freqLabel = document.querySelector('[data-sub-frequency-label]');

  function getAllChips() {
    return Array.prototype.slice.call(document.querySelectorAll('.po__frequency-chip'));
  }

  function activateChip(chip) {
    if (!chip) return;
    var chips = getAllChips();
    chips.forEach(function (c) {
      c.classList.remove('active');
      c.setAttribute('aria-checked', 'false');
      c.setAttribute('tabindex', '-1');
    });
    chip.classList.add('active');
    chip.setAttribute('aria-checked', 'true');
    chip.setAttribute('tabindex', '0');
    state.sellingPlanId = chip.dataset.planId || null;
    state.po = 'sub';
    state.totalCents = null;
    var subCard = document.querySelector('.po__card[data-po="sub"]');
    var oneCard = document.querySelector('.po__card[data-po="one"]');
    if (subCard) { subCard.classList.add('active'); subCard.setAttribute('aria-checked', 'true'); }
    if (oneCard) { oneCard.classList.remove('active'); oneCard.setAttribute('aria-checked', 'false'); }
    if (freqSelect) {
      freqSelect.removeAttribute('disabled');
      freqSelect.value = state.sellingPlanId || '';
      freqSelect.setAttribute('disabled', '');
    }
    if (freqLabel && chip.dataset.planName) {
      freqLabel.textContent = chip.dataset.planName + ' · Pause, swap, or cancel anytime';
    }
    syncSellingPlan();
    recalc();
    if (typeof pushToRecharge === 'function') pushToRecharge();
  }

  // Single delegated click handler on document — works for any chip on the page
  // regardless of when it was injected. No DOM-ready timing issues.
  document.addEventListener('click', function (e) {
    var chip = e.target && e.target.closest ? e.target.closest('.po__frequency-chip') : null;
    if (!chip) return;
    e.preventDefault();
    e.stopPropagation();
    try {
      activateChip(chip);
    } catch (err) {
      console.warn('[chip] activate failed', err);
    }
  }, true); // useCapture=true → catch click in capture phase before any other listener can stopPropagation

  // Keyboard nav across chips
  document.addEventListener('keydown', function (e) {
    var chip = e.target && e.target.closest ? e.target.closest('.po__frequency-chip') : null;
    if (!chip) return;
    var chips = getAllChips();
    var idx = chips.indexOf(chip);
    if (idx === -1) return;
    var next = null;
    if (e.key === 'ArrowRight' || e.key === 'ArrowDown') next = chips[(idx + 1) % chips.length];
    else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') next = chips[(idx - 1 + chips.length) % chips.length];
    else if (e.key === 'Home') next = chips[0];
    else if (e.key === 'End') next = chips[chips.length - 1];
    else if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); chip.click(); return; }
    if (next) {
      e.preventDefault();
      next.focus();
      next.click();
    }
  });

  /* ────────── Recharge sync ──────────────────────────────────────────────
     Recharge's widget.min.js auto-injects inside [data-rc-mount] (invisible
     via CSS). We use Recharge as the SOURCE OF TRUTH for prices, % discount,
     and plan options — every value gets mirrored into my styled .po card UI.

     On every change, we also push the user's choice back into Recharge so the
     two stay aligned. Our hidden <input name="selling_plan"> is the sole
     form-submission field; we strip Recharge's own `name` attr on first mount.
     ──────────────────────────────────────────────────────────────────────── */
  var rcMount = document.querySelector('[data-rc-mount]');
  // Embed mode renders the real Recharge widget visibly with no .po card to
  // sync into, so the mirroring/push logic below has nothing to do.
  if (rcMount && rcMount.classList.contains('rc-mount--embedded')) {
    rcMount = null;
  }
  var rcInitialized = false;

  function rcText(el) { return el ? (el.textContent || '').trim() : ''; }

  // Recharge auto-mounts somewhere on the page (sometimes inside .rc-mount,
  // sometimes near the form). Search the whole document for its data attrs.
  function pullFromRecharge() {
    var subPriceEl = document.querySelector('[data-price-subsave]');
    var discountEl = document.querySelector('[data-label-discount]');
    var onetimePriceEl = document.querySelector('[data-price-onetime]');

    var poUnitSubEl = document.querySelector('[data-po-unit="sub"]');
    var poUnitOneEl = document.querySelector('[data-po-unit="one"]');
    var poCompareEl = document.querySelector('[data-po-compare]');
    var subBadgeEl = document.querySelector('[data-sub-discount-badge]');
    var atcTotalEl = document.getElementById('atc-total');

    // Mirror Recharge's price text into the styled UI (truth wins).
    if (subPriceEl && poUnitSubEl) {
      var subText = rcText(subPriceEl);
      if (subText) poUnitSubEl.textContent = subText;
    }
    if (onetimePriceEl && poUnitOneEl) {
      var oneText = rcText(onetimePriceEl);
      if (oneText) {
        poUnitOneEl.textContent = oneText;
        // Also use Recharge's one-time price as the compare strikethrough on sub
        if (poCompareEl) poCompareEl.textContent = oneText;
      }
    }
    if (discountEl && subBadgeEl) {
      var d = rcText(discountEl).replace(/^[-−]/, '').trim();
      if (d) subBadgeEl.textContent = '-' + d;
    }
    // Let recalc() own the ATC total so it reflects quantity (e.g. Two Tubs =
    // qty 2) and the first-delivery subscription discount, rather than Recharge's
    // raw per-unit price (which ignores both).
    recalc();

    // Sync frequency dropdown options from Recharge's list.
    var rcSelect = document.querySelector('[data-plans-dropdown]');
    if (rcSelect && freqSelect && rcSelect.options.length > 0 && freqSelect.options.length !== rcSelect.options.length) {
      var prev = freqSelect.value;
      freqSelect.innerHTML = '';
      Array.prototype.forEach.call(rcSelect.options, function (opt) {
        var newOpt = document.createElement('option');
        newOpt.value = opt.value;
        newOpt.textContent = opt.textContent;
        if (opt.value === prev || opt.selected) newOpt.selected = true;
        freqSelect.appendChild(newOpt);
      });
    }
    // INTENTIONALLY DO NOT sync state.sellingPlanId from Recharge's select.
    // My .po__frequency-chip clicks are the source of truth for cadence.
    // Recharge's hidden select always shows its default (30-day) — mirroring
    // it would revert the user's chip choice every 500ms (same pattern as the
    // state.po revert bug we already fixed).

    // INTENTIONALLY DO NOT sync Subscribe/One-time selection from Recharge.
    // My .po__card click handlers are the source of truth for sub vs one-time.
    // Recharge's widget defaults to one-time on fresh page loads — if we
    // mirror that, my UI's "Subscribe" selection gets reverted every 500ms.
  }

  function pushToRecharge() {
    if (!rcMount) return;
    var rcSubRadio = rcMount.querySelector('[data-radio-subsave]');
    var rcOneRadio = rcMount.querySelector('[data-radio-onetime]');
    var rcSelect = rcMount.querySelector('[data-plans-dropdown]');

    if (state.po === 'sub') {
      if (rcSubRadio && !rcSubRadio.checked) {
        rcSubRadio.checked = true;
        rcSubRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } else if (rcOneRadio && !rcOneRadio.checked) {
      rcOneRadio.checked = true;
      rcOneRadio.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (rcSelect && state.sellingPlanId && rcSelect.value !== String(state.sellingPlanId)) {
      rcSelect.value = String(state.sellingPlanId);
      rcSelect.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function initRechargeSync() {
    if (rcInitialized || !rcMount) return;
    if (!rcMount.querySelector('.rc-container, .rc-widget')) return;
    rcInitialized = true;

    // Recharge ships its own <select name="selling_plan"> inside the form.
    // Strip its name so our <input name="selling_plan"> wins on submit.
    var rcStrayInputs = rcMount.querySelectorAll('[name="selling_plan"]');
    Array.prototype.forEach.call(rcStrayInputs, function (el) {
      el.removeAttribute('name');
    });

    pullFromRecharge();

    // Observe any internal Recharge change → pull again.
    var changeObserver = new MutationObserver(pullFromRecharge);
    changeObserver.observe(rcMount, { childList: true, subtree: true, characterData: true, attributes: true });
    // Also catch click/change events bubbling out of Recharge's widget.
    rcMount.addEventListener('change', pullFromRecharge);
    rcMount.addEventListener('click', function () { setTimeout(pullFromRecharge, 50); });
  }

  if (rcMount) {
    var mountObserver = new MutationObserver(initRechargeSync);
    mountObserver.observe(rcMount, { childList: true, subtree: true });
    initRechargeSync();
  }
  // Polling backstop — Recharge widget often mounts OUTSIDE [data-rc-mount]
  // (we hide it via CSS regardless). Re-scan the full document every 500ms for
  // the first 12s so we catch the prices wherever they appear.
  var pullPolls = 0;
  var pullInterval = setInterval(function () {
    pullPolls += 1;
    pullFromRecharge();
    // Also catch the broader Recharge widget instance for its data attributes
    if (!rcInitialized) {
      var anyRecharge = document.querySelector('.rc-container, .rc-widget, [data-widget-container]');
      if (anyRecharge) {
        rcInitialized = true;
        var rcStrayInputs = document.querySelectorAll('[data-widget-container] [name="selling_plan"], .rc-container [name="selling_plan"], .rc-widget [name="selling_plan"]');
        Array.prototype.forEach.call(rcStrayInputs, function (el) { el.removeAttribute('name'); });
      }
    }
    if (pullPolls >= 24) clearInterval(pullInterval); // 24 * 500ms = 12s
  }, 500);
  // One more pull on full load
  window.addEventListener('load', function () { setTimeout(pullFromRecharge, 1000); });

  if (qtyPills.length) {
    var activeQty = document.querySelector('.qty-pill.active');
    state.qty = activeQty ? parseInt(activeQty.dataset.qty, 10) : 1;
  }
  if (!hasSellingPlan) {
    state.po = 'one';
    poCards.forEach(function (card) {
      var isOne = card.dataset.po === 'one';
      card.classList.toggle('active', isOne);
      card.setAttribute('aria-checked', isOne ? 'true' : 'false');
    });
  }
  recalc();

  var etaEl = document.getElementById('etaRange');
  if (etaEl) {
    function addBusinessDays(start, days) {
      var d = new Date(start.getTime());
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) added += 1;
      }
      return d;
    }
    function fmt(d) {
      return d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' });
    }
    var now = new Date();
    etaEl.textContent = fmt(addBusinessDays(now, 4)) + ' – ' + fmt(addBusinessDays(now, 6));
  }

  var fbtGrid = document.getElementById('fbtGrid');
  if (fbtGrid) {
    var fbtCards = fbtGrid.querySelectorAll('.fbt-card');
    var fbtTotalEl = document.getElementById('fbtTotal');
    var fbtSeparateEl = document.getElementById('fbtSeparate');
    var fbtSaveEl = document.getElementById('fbtSave');
    var fbtBtnTotalEl = document.getElementById('fbtBtnTotal');
    var fbtAddBtn = document.getElementById('fbtAddBtn');
    var bundleDiscountPct = parseFloat(fbtGrid.dataset.bundleDiscountPct);
    if (isNaN(bundleDiscountPct)) bundleDiscountPct = 10;
    var bundleDiscount = bundleDiscountPct / 100;

    function fbtCardPriceCents(card) {
      var cents = parseInt(card.dataset.priceCents, 10);
      if (!isNaN(cents) && cents > 0) return cents;
      var legacy = parseFloat(card.dataset.price);
      if (!isNaN(legacy) && legacy > 0) return Math.round(legacy * 100);
      return 0;
    }

    function recalcFbt() {
      var sumCents = 0;
      var count = 0;
      fbtCards.forEach(function (c) {
        if (c.classList.contains('checked')) {
          sumCents += fbtCardPriceCents(c);
          count += 1;
        }
      });
      var discountedCents = count >= 2 ? Math.round(sumCents * (1 - bundleDiscount)) : sumCents;
      var savedCents = sumCents - discountedCents;

      if (fbtTotalEl) fbtTotalEl.textContent = formatMoney(discountedCents);
      if (fbtBtnTotalEl) fbtBtnTotalEl.textContent = formatMoney(discountedCents);

      // Only show the strikethrough + savings line when there's a real saving.
      // No fake "Save $0.00 · 0% off" claims.
      var hasRealSaving = count >= 2 && savedCents > 0 && bundleDiscount > 0;
      if (hasRealSaving && fbtSeparateEl && fbtSaveEl) {
        fbtSeparateEl.hidden = false;
        fbtSeparateEl.textContent = formatMoney(sumCents);
        fbtSaveEl.hidden = false;
        fbtSaveEl.textContent = 'Save ' + formatMoney(savedCents) + ' · ' + Math.round(bundleDiscountPct) + '% off when bought together';
      } else if (fbtSeparateEl && fbtSaveEl) {
        fbtSeparateEl.hidden = true;
        fbtSaveEl.hidden = true;
        fbtSaveEl.textContent = '';
      }

      if (fbtAddBtn) {
        fbtAddBtn.disabled = count < 2;
      }
    }

    fbtCards.forEach(function (c) {
      c.addEventListener('click', function (e) {
        e.preventDefault();
        if (c.dataset.locked === 'true') return;
        c.classList.toggle('checked');
        var checkbox = c.querySelector('input[type="checkbox"]');
        if (checkbox && !checkbox.disabled) checkbox.checked = c.classList.contains('checked');
        recalcFbt();
      });
    });

    if (fbtAddBtn) {
      var fbtBtnDefault = fbtAddBtn.innerHTML;
      fbtAddBtn.addEventListener('click', function () {
        var items = [];
        fbtCards.forEach(function (c) {
          if (c.classList.contains('checked') && c.dataset.variantId) {
            items.push({
              id: parseInt(c.dataset.variantId, 10),
              quantity: 1
            });
          }
        });
        if (items.length < 2) return;

        fbtAddBtn.disabled = true;
        fbtAddBtn.textContent = 'Adding…';
        var addUrl = (cfg.routes && cfg.routes.cartAddUrl ? cfg.routes.cartAddUrl : '/cart/add') + '.js';

        fetch(addUrl, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({ items: items })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                throw new Error((err && err.description) || 'We could not add this bundle. Please try again.');
              });
            }
            return res.json();
          })
          .then(function () {
            if (window.ultimateLiving && typeof window.ultimateLiving.fetchCart === 'function') {
              return window.ultimateLiving.fetchCart();
            }
          })
          .then(function () {
            window.location.href = cfg.routes && cfg.routes.cartUrl ? cfg.routes.cartUrl : '/cart';
          })
          .catch(function (err) {
            fbtAddBtn.disabled = false;
            fbtAddBtn.innerHTML = fbtBtnDefault;
            var msg = (err && err.message) || 'We could not add this bundle. Please try again.';
            var existing = fbtAddBtn.parentNode.querySelector('.fbt-error');
            if (existing) existing.remove();
            var note = document.createElement('div');
            note.className = 'fbt-error';
            note.setAttribute('role', 'alert');
            note.textContent = msg;
            fbtAddBtn.parentNode.appendChild(note);
            setTimeout(function () { if (note.parentNode) note.remove(); }, 5000);
          });
      });
    }

    recalcFbt();
  }

  /* ────────── Gallery: swipe-snap track + arrows + dots + thumbs ────────── */
  (function initGallery() {
    var gallery = document.querySelector('[data-gallery]');
    if (!gallery) return;
    var track = gallery.querySelector('[data-gallery-track]');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.gallery__slide')) : [];
    if (!track || slides.length === 0) return;
    var dots = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-dots] .gallery__dot'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.gallery__thumbs .gallery__thumb'));
    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');

    var activeIdx = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
    if (activeIdx < 0) activeIdx = 0;

    function setActive(idx) {
      activeIdx = Math.max(0, Math.min(slides.length - 1, idx));
      slides.forEach(function (s, i) { s.classList.toggle('is-active', i === activeIdx); });
      dots.forEach(function (d, i) {
        d.classList.toggle('is-active', i === activeIdx);
        d.setAttribute('aria-current', i === activeIdx ? 'true' : 'false');
      });
      thumbs.forEach(function (t, i) {
        t.classList.toggle('is-active', i === activeIdx);
        t.setAttribute('aria-selected', i === activeIdx ? 'true' : 'false');
      });
    }

    // Click handlers
    function clickGoTo(node) {
      node.addEventListener('click', function () {
        var i = parseInt(node.dataset.goTo, 10);
        if (!isNaN(i)) setActive(i);
      });
    }
    dots.forEach(clickGoTo);
    thumbs.forEach(clickGoTo);
    if (prevBtn) prevBtn.addEventListener('click', function () { setActive(activeIdx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { setActive(activeIdx + 1); });

    // Expose to variant change handler and tier switcher
    window.__galleryScrollToMediaId = function (mediaId) {
      var idx = slides.findIndex(function (s) { return parseInt(s.dataset.slideId, 10) === mediaId; });
      if (idx >= 0) setActive(idx);
    };
    window.__galleryScrollToIndex = function (idx) {
      setActive(idx);
    };
  })();

  var productForm = document.getElementById('product-form');
  // This whole file's .po card / qty-pill logic (poRoot, poCards, state.po)
  // is the old purchase-option UI. The block-driven main-product.liquid that
  // replaced it has none of that markup, but this file still loads and its
  // submit listener was overwriting the new template's own selling_plan
  // sync: state.po stays 'one' (never 'sub', since nothing here ever sets
  // it for the new markup), so syncSellingPlan() unconditionally cleared the
  // field on every submit, right after the new inline script had set it
  // correctly. Confirmed live: the field read a correct plan id right
  // before submit, then the cart still showed one-time. Skip all of this
  // file's form-submission handling when the .po markup it depends on
  // doesn't exist, rather than guessing at state it was never given.
  if (productForm && poRoot) {
    productForm.addEventListener('submit', function () {
      if (qtyInput) qtyInput.value = String(state.qty);
      if (variantInput && currentVariant()) {
        variantInput.value = String(currentVariant().id);
      }
      syncSellingPlan();

      // Strip name="selling_plan" from EVERY field that isn't ours, so the
      // form posts only OUR chip-driven value. Recharge's widget injects its
      // own <select name="selling_plan"> which would otherwise override ours
      // (last-named-field wins when duplicates exist).
      document.querySelectorAll('[name="selling_plan"]').forEach(function (el) {
        if (!el.hasAttribute('data-selling-plan-input')) {
          el.removeAttribute('name');
        }
      });
    });
    // Belt-and-suspenders: an interval that keeps stripping name from any
    // Recharge selling_plan field after it (re-)mounts.
    setInterval(function () {
      document.querySelectorAll('[name="selling_plan"]').forEach(function (el) {
        if (!el.hasAttribute('data-selling-plan-input')) {
          el.removeAttribute('name');
        }
      });
    }, 1000);
  }
})();
